import React from "react";
import { LogOut } from "lucide-react";
import { useLang } from "../i18n";

export function quickExit() {
  const url = "https://www.google.com/search?q=weather";
  try {
    if (window.top && window.top !== window.self) {
      // Inside an iframe (e.g. the preview): navigate the whole top window out.
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
    return;
  } catch (e) {
    // Sandboxed iframe blocked top navigation — open weather in a fresh tab.
    window.open(url, "_blank", "noopener");
  }
}

export function QuickExitButton({ className = "" }) {
  const { t } = useLang();
  return (
    <button
      data-testid="quick-exit-btn"
      onClick={quickExit}
      className={`inline-flex items-center gap-2 rounded-full bg-danger px-4 py-2 text-sm font-medium text-white shadow-soft transition-colors hover:bg-red-600 ${className}`}
      aria-label={t("quick_exit")}
    >
      <LogOut size={16} strokeWidth={1.75} />
      {t("quick_exit")}
    </button>
  );
}
